import React from 'react';
import { ShoppingBasket } from 'lucide-react';
import { PulsePanel } from './PulsePanel';

const Stat = ({ value, label, color, testid }) => (
  <div className="text-center leading-none">
    <div className="text-[40px] font-extrabold tabular-nums" style={{ color }} data-testid={testid}>{value}</div>
    <div className="text-[14px] font-semibold mt-1 whitespace-nowrap">{label}</div>
  </div>
);

export const PulseFoodPantry = ({ rows }) => (
  <PulsePanel icon={ShoppingBasket} title="Food Pantry Check-in Queue" pill="Today" testid="pulse-food-pantry" className="h-full">
    <div className="flex-1 min-h-0 grid grid-cols-2 gap-5 px-4 py-2.5">
      {rows.map((r) => (
        <div key={r.location} className="flex items-center gap-3 min-w-0" data-testid={`pulse-food-pantry-${r.location.toLowerCase()}`}>
          <span className="text-[17px] font-medium shrink-0" data-testid="pulse-food-pantry-name">{r.location}</span>
          <div className="flex-1 self-stretch rounded-xl bg-[#f6eef7] flex items-center justify-center gap-5 px-4" data-testid="pulse-food-pantry-location">
            <Stat value={r.total} label="Total Today" color="#922A8C" testid="pulse-food-pantry-total" />
            <div className="w-px self-stretch my-3 bg-[#e3d2e6]" />
            <Stat value={r.new_clients} label="New Clients" color="#22B04B" testid="pulse-food-pantry-new" />
          </div>
        </div>
      ))}
    </div>
  </PulsePanel>
);
